import {MIN_POSSIBLE_VALUES_INPUTS_COUNT} from 'src/modules/event-create/attributes-block/constants';
import {PossibleValueInput} from 'src/modules/event-create/attributes-block/typedefs';

export const createPossibleValueInputs = (
    possibleValues: string[],
): PossibleValueInput[] => {
    const values = possibleValues.map(value => ({value, isEmptySlot: false}));

    const emptySlotsCount = Math.max(MIN_POSSIBLE_VALUES_INPUTS_COUNT - values.length, 0);

    return [
        ...values,
        ...Array.from({length: emptySlotsCount}, () => ({value: '', isEmptySlot: true})),
    ];
};
